import { render, staticRenderFns } from "./RatingStarsBar.vue?vue&type=template&id=4fcd7d4e&scoped=true&"
import script from "./RatingStarsBar.vue?vue&type=script&lang=ts&"
export * from "./RatingStarsBar.vue?vue&type=script&lang=ts&"
import style0 from "./RatingStarsBar.vue?vue&type=style&index=0&id=4fcd7d4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcd7d4e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconsStarIcon16px: require('/var/www/packages/theme/components/icons/star/StarIcon16px.vue').default})
